/* Valeurs métier Celestiar : seul endroit à modifier pour les formats, seuils et délais. */
window.CELESTIAR_CONFIG = {
  DPI_TARGET: 300,
  DPI_GREEN: 200,
  DPI_ORANGE: 120,
  MAX_UPLOAD_MB: 24,
  IDEAL_RATIO_TOLERANCE: 0.03,
  RETENTION_DAYS: 30,
  SUPPORT_RESPONSE_TIME: '24h',
  FREE_SHIPPING_COUNTRIES: ['FR', 'BE'],
  /* Dimensions réelles d'impression (mm) chez Gelato ; pixels = mm / 25,4 x 300.
     Le 13 x 18 est imprimé en 127 x 177,8 mm (5 x 7 pouces). */
  FORMATS: [
    { id: '13x18',  label: '13 × 18 cm',        mmW: 127, mmH: 177.8 },
    { id: '20x25',  label: '20 × 25 cm',        mmW: 200, mmH: 250 },
    { id: 'a4',     label: '21 × 29,7 cm (A4)', mmW: 210, mmH: 297 },
    { id: '30x40',  label: '30 × 40 cm',        mmW: 300, mmH: 400 },
    { id: '40x50',  label: '40 × 50 cm',        mmW: 400, mmH: 500 },
    { id: '50x70',  label: '50 × 70 cm',        mmW: 500, mmH: 700 },
    { id: '60x90',  label: '60 × 90 cm',        mmW: 600, mmH: 900 },
    { id: '70x100', label: '70 × 100 cm',       mmW: 700, mmH: 1000 }
  ]
};
window.CELESTIAR_CONFIG.FORMATS.forEach(function (f) {
  f.pxW = Math.round(f.mmW / 25.4 * window.CELESTIAR_CONFIG.DPI_TARGET);
  f.pxH = Math.round(f.mmH / 25.4 * window.CELESTIAR_CONFIG.DPI_TARGET);
});
